<template>
    <span>
        <span
            class="q-mr-sm text-negative"
            v-if="showError">Twoja sesja wygaśnie za {{$store.state.timeToLogoutString}}
            - <a
                @click.prevent="exdendSession"
                class="text-negative"
                href="#"
                v-if="showError || showWarning">Przedłuż sesję</a></span>

        <span
            class="q-mr-sm text-warning"
            v-else-if="showWarning">Twoja sesja wygaśnie za {{$store.state.timeToLogoutString}}
            - <a
                @click.prevent="exdendSession"
                class="text-warning"
                href="#"
                v-if="showError || showWarning">Przedłuż sesję</a></span>
    </span>
</template>

<script>
    export default {
        name: 'TimeToLogout',
        computed: {
            showWarning () {
                return this.$store.state.logoutIn < 10 * 60 // logout in < 10m
            },
            showError () {
                return this.$store.state.logoutIn < 5 * 60 // logout in < 5m
            },
        },
        methods: {
            exdendSession() {
                this.$store.dispatch('checkAuth')
            }
        }
    }
</script>

<style scoped>

</style>